import { useJobs } from '../hooks/queries/useJobs';
import { HiOutlineLightningBolt, HiPlus } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants';
import TitleWIthDescription from '../components/TitleWithDesc/TitleWIthDescription';
import JobCard from '../components/JobCard/Jobcard';
import JobCardSkeleton from '../components/JobCard/JobCardSkeleton';
import { trackCTAClick } from '../Actions/analytics';

const JobPosting = () => {
  const { isLoading: loading, data: Jobs } = useJobs();
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto pb-20">
      <TitleWIthDescription
        title1="Career Opportunities"
        title2="Just For You!"
        description="Handpicked openings from top companies to help you land your dream campus placement."
      />

      {/* Message Bar / Quick Stats */}
      <div className="px-4 mb-8">
        <div className="bg-slate-900 rounded-3xl p-4 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-xl shadow-slate-100">
          <div className="flex items-center gap-3 ml-2">
            <div className="bg-blue-500 p-2 rounded-xl text-white">
              <HiOutlineLightningBolt size={20} />
            </div>
            <div>
              <p className="text-white text-sm font-black">Daily Updates</p>
              <p className="text-slate-400 text-[11px] font-bold uppercase tracking-widest">New jobs added every 24 hours</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-6 mr-2">
            <div className="flex items-center gap-6">
              <div className="text-center hidden sm:block">
                <p className="text-blue-400 text-lg font-black">{Jobs?.job?.length || 0}</p>
                <p className="text-slate-500 text-[9px] font-black uppercase">Active Leads</p>
              </div>
              <div className="h-8 w-px bg-slate-800 hidden sm:block"></div>
              <div className="text-center hidden sm:block">
                <p className="text-white text-lg font-black">100%</p>
                <p className="text-slate-500 text-[9px] font-black uppercase">Verified</p>
              </div>
            </div>
            
            <button
              onClick={() => { trackCTAClick('post_a_job', ROUTES.createJob); navigate(ROUTES.createJob); }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-xl font-bold text-sm transition-all active:scale-95 shadow-lg shadow-blue-500/20 flex items-center gap-2"
            >
              <HiPlus size={18} />
              Post a Job
            </button>
          </div>
        </div>
      </div>

      <div className="px-4">
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 py-10">
            {[1, 2, 3].map((i) => (
              <JobCardSkeleton key={i} />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {Jobs?.job?.map((job) => (
              <JobCard key={job._id} job={job} />
            ))}
          </div>
        )}

        {!loading && Jobs?.job?.length === 0 && (
          <div className="relative overflow-hidden text-center py-24 bg-white rounded-[3rem] border border-slate-100 shadow-2xl shadow-blue-50 group">
            {/* Background Animations */}
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-50 via-transparent to-purple-50 opacity-50 group-hover:opacity-100 transition-opacity duration-700"></div>
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-blue-400/10 rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-purple-400/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>

            <div className="relative z-10 flex flex-col items-center justify-center">
              <div className="w-24 h-24 bg-gradient-to-tr from-blue-100 to-indigo-100 rounded-full flex items-center justify-center mb-6 shadow-inner relative">
                <div className="absolute inset-0 border-4 border-white rounded-full"></div>
                <HiOutlineLightningBolt className="text-blue-600 animate-bounce" size={40} />
              </div>
              <h3 className="text-3xl font-black text-slate-800 mb-4 tracking-tight">The Board is Empty!</h3>
              <p className="text-slate-500 font-medium max-w-md mx-auto mb-8 leading-relaxed">
                Be the spark that ignites someone's career. Share an internship or job opening and help your peers land their dream roles!
              </p>
              <button
                onClick={() => navigate(ROUTES.createJob)}
                className="bg-slate-900 hover:bg-blue-600 text-white font-black uppercase tracking-widest text-xs px-8 py-4 rounded-2xl transition-all shadow-xl hover:shadow-blue-500/30 active:scale-95 flex items-center gap-3"
              >
                <HiPlus size={18} />
                Share an Opportunity
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobPosting;